import { render, staticRenderFns } from "./assigned-agencies.vue?vue&type=template&id=55e5890e"
import script from "./assigned-agencies.vue?vue&type=script&lang=js"
export * from "./assigned-agencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports